import { reducers } from "@insite/client-framework/Store/Reducers";
import toolkitReducer from "@toolkit/Framework/Store/Toolkit/ToolkitReducer";

(reducers as any).toolkit = toolkitReducer;
